import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    TITLE: {
        id: 'admin.courtesyCarsPricing.title',
        defaultMessage: 'Courtesy cars pricing'
    },
    SELECT_COUNTRY: {
        id: 'admin.courtesyCarsPricing.selectCountry',
        defaultMessage: 'Select a country'
    },
    COURTESY_CARS_PRICING: {
        id: 'admin.courtesyCarsPricing.courtesyCarsPricing',
        defaultMessage: 'Courtesy cars pricing'
    },
    PLACEHOLDER_COURTESY_CARS_PRICING: {
        id: 'admin.courtesyCarsPricing.courtesyCarsPricing.placeholder',
        defaultMessage: 'Courtesy cars pricing'
    },
    LEVEL: {
        id: 'admin.courtesyCarsPricing.level',
        defaultMessage: 'Level'
    },
    DAILY_RATE: {
        id: 'admin.courtesyCarsPricing.dailyRate',
        defaultMessage: 'Daily rate (EUR)'
    },
    DAILY_RATE_LOCAL: {
        id: 'admin.courtesyCarsPricing.dailyRate.local',
        defaultMessage: 'Daily rate (local)'
    },
    PLACEHOLDER_DAILY_RATE: {
        id: 'admin.courtesyCarsPricing.dailyRate.placeholder',
        defaultMessage: 'Enter daily rate (EUR)'
    },
    PLACEHOLDER_DAILY_RATE_LOCAL: {
        id: 'admin.courtesyCarsPricing.dailyRate.local.placeholder',
        defaultMessage: 'Enter daily rate (local)'
    }
});

export default messages;
